import React, { Component } from 'react'
import Link from 'gatsby-link'
import { PrimaryH3, SecondaryP, ColorOverlay } from './styled-components.js'

export default class ImageBlock extends Component {
  constructor() {
    super()
    this.state = {
      hoverState: false,
    }
  }

  hover = () => {
    this.setState({ hoverState: true })
  }

  unhover = () => {
    this.setState({ hoverState: false })
  }

  render() {
    const { component } = this.props
    const isFullPage = component.imageContentColumnWidth === 'full-page'
    !component.primaryColor && (component.primaryColor = '#000')
    !component.secondaryColor && (component.secondaryColor = '#8f8f8f')
    const textColor = this.state.hoverState
      ? component.primaryColor
      : component.secondaryColor
    const overLayColor = this.state.hoverState
      ? component.imageOverlayColor
      : null

    const SpanCaptionTitle = () => (
      <span
        onMouseEnter={this.hover}
        onMouseLeave={this.unhover}
        dangerouslySetInnerHTML={{
          __html: component.captionTitle,
        }}
      />
    )

    const SpanCaptionCopy = () => (
      <span
        onMouseEnter={this.hover}
        onMouseLeave={this.unhover}
        dangerouslySetInnerHTML={{
          __html: component.captionCopy.captionCopy,
        }}
      />
    )

    const FigCaption = () => (
      <figcaption className="text-container">
        {component.captionTitle && (
          <PrimaryH3 primaryTextColor={component.primaryColor}>
            <span
              dangerouslySetInnerHTML={{
                __html: component.captionTitle,
              }}
            />
          </PrimaryH3>
        )}
        {component.captionCopy && (
          <SecondaryP secondaryTextColor={textColor}>
            <span
              dangerouslySetInnerHTML={{
                __html: component.captionCopy.captionCopy,
              }}
            />
          </SecondaryP>
        )}
      </figcaption>
    )

    const startCol = component.captionShiftContent
    const mobileAlignment =
      startCol === '0-col' ||
      startCol === '1-col' ||
      startCol === '2-col' ||
      startCol === '3-col' ||
      startCol === '4-col' ||
      startCol === '5-col'
        ? 'mobile-left-half'
        : 'mobile-right-half'

    return (
      <section
        className={`component image-block margin-${component.marginBelow}`}
      >
        <div className={`grid-row ${isFullPage ? 'full-page' : ''}`}>
          <figure
            className={`image block width-${
              component.imageContentColumnWidth
            } shift-${component.imageShiftContent}`}
          >
            {component.image && <img src={`${component.image.file.url}`} />}

            {component.imageExternalLink && (
              <a href={component.imageExternalLink} target="_blank">
                <ColorOverlay
                  onMouseEnter={this.hover}
                  onMouseLeave={this.unhover}
                  hoverColor={overLayColor}
                />
              </a>
            )}

            {component.imageCaseStudyReference && (
              <Link
                to={`/case-study/${component.imageCaseStudyReference.slug}`}
              >
                <ColorOverlay
                  onMouseEnter={this.hover}
                  onMouseLeave={this.unhover}
                  hoverColor={overLayColor}
                />
              </Link>
            )}
          </figure>
        </div>

        <div className="grid-row">
          {component.imageExternalLink &&
            (component.captionTitle || component.captionCopy) && (
              <figure
                className={`caption-content block width-${
                  component.captionContentColumnWidth
                } shift-${component.captionShiftContent} ${mobileAlignment}`}
              >
                <figcaption className="text-container">
                  {component.captionTitle && (
                    <PrimaryH3 primaryTextColor={component.primaryColor}>
                      <a href={component.imageExternalLink} target="_blank">
                        <SpanCaptionTitle />
                      </a>
                    </PrimaryH3>
                  )}
                  {component.captionCopy && (
                    <SecondaryP secondaryTextColor={textColor}>
                      <a href={component.imageExternalLink} target="_blank">
                        <SpanCaptionCopy />
                      </a>
                    </SecondaryP>
                  )}
                </figcaption>
              </figure>
            )}

          {component.imageCaseStudyReference &&
            (component.captionTitle || component.captionCopy) && (
              <figure
                className={`caption-content block width-${
                  component.captionContentColumnWidth
                } shift-${component.captionShiftContent} ${mobileAlignment}`}
              >
                <figcaption className="text-container">
                  {component.captionTitle && (
                    <PrimaryH3 primaryTextColor={component.primaryColor}>
                      <Link
                        to={`/case-study/${
                          component.imageCaseStudyReference.slug
                        }`}
                      >
                        <SpanCaptionTitle />
                      </Link>
                    </PrimaryH3>
                  )}
                  {component.captionCopy && (
                    <SecondaryP secondaryTextColor={textColor}>
                      <Link
                        to={`/case-study/${
                          component.imageCaseStudyReference.slug
                        }`}
                      >
                        <SpanCaptionCopy />
                      </Link>
                    </SecondaryP>
                  )}
                </figcaption>
              </figure>
            )}

          {!component.imageExternalLink &&
            !component.imageCaseStudyReference &&
            (component.captionTitle || component.captionCopy) && (
              <figure
                className={`caption-content block width-${
                  component.captionContentColumnWidth
                } shift-${component.captionShiftContent} ${mobileAlignment}`}
              >
                <FigCaption />
              </figure>
            )}
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/shared-page-components/image-block.js